var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            rules: _vm.rules,
            model: _vm.childData,
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex" } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.menuMenuName"),
                        prop: "menuName"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.menuName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "menuName", $$v)
                          },
                          expression: "childData.menuName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.menuUpidName") } },
                    [
                      _c("el-cascader", {
                        staticClass: "form-item-width",
                        attrs: {
                          clearable: "",
                          options: _vm.options,
                          props: _vm.propstree,
                          "change-on-select": ""
                        },
                        model: {
                          value: _vm.menuUpId,
                          callback: function($$v) {
                            _vm.menuUpId = $$v
                          },
                          expression: "menuUpId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.menuVueTarget"),
                            prop: "menuVueTarget"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-width",
                              attrs: { placeholder: "请选择菜单目标" },
                              model: {
                                value: _vm.childData.menuVueTarget,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "menuVueTarget", $$v)
                                },
                                expression: "childData.menuVueTarget"
                              }
                            },
                            _vm._l(_vm.targetOption, function(item) {
                              return _c("el-option", {
                                key: item.vlue,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.menuIcon"),
                            prop: "menuIcon"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "form-item-width",
                            model: {
                              value: _vm.childData.menuIcon,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "menuIcon", $$v)
                              },
                              expression: "childData.menuIcon"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.menuOrder"),
                            prop: "menuOrder"
                          }
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "form-item-number",
                            attrs: { min: 1, max: 99 },
                            model: {
                              value: _vm.childData.menuOrder,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "menuOrder", $$v)
                              },
                              expression: "childData.menuOrder"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("table.menuType") } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.selectedMenuTypeList,
                                callback: function($$v) {
                                  _vm.selectedMenuTypeList = $$v
                                },
                                expression: "selectedMenuTypeList"
                              }
                            },
                            _vm._l(_vm.menuTypes, function(item) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: item.dicValue,
                                  attrs: { label: item.dicValue, border: "" }
                                },
                                [_vm._v(_vm._s(item.dicName))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.menuVirtualUrl"),
                        prop: "menuVirtualUrl"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-texarea",
                        model: {
                          value: _vm.childData.menuVirtualUrl,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "menuVirtualUrl", $$v)
                          },
                          expression: "childData.menuVirtualUrl"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.menuVueUrl") } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-texarea",
                        model: {
                          value: _vm.childData.menuVueUrl,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "menuVueUrl", $$v)
                          },
                          expression: "childData.menuVueUrl"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.menuDesc") } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-texarea",
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 4, maxRows: 4 }
                        },
                        model: {
                          value: _vm.childData.menuDesc,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "menuDesc", $$v)
                          },
                          expression: "childData.menuDesc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }